import React, {Component, Fragment} from 'react';
import {connect} from "react-redux";
import {IRootState} from "../../../store";
import DispatchProps from "../../../utils/DispatchProps";
import School from "../../../models/School";
import {CommandBarButton, MessageBarType,} from "office-ui-fabric-react";
import Actions from "../../../redux/Actions";
import ApiService from "../../ApiService";
import H from "history";
import {diff as DiffEditor} from "react-ace";
import "ace-builds/src-noconflict/mode-xml";
import "ace-builds/src-noconflict/snippets/xml";
import AceEditor from "react-ace";
import SampleConfig from './SampleConfig';
import SchoolPageTitle from '../../SchoolPageTitle';
import AdminSchoolMenu from '../../AdminSchoolMenu';

const diffHighlightStyleFix = document.createElement('style');
diffHighlightStyleFix.innerHTML = ".codeMarker { background: #fff677; position: absolute; z-index: 20; }";
document.querySelector('head')!.appendChild(diffHighlightStyleFix);

interface ConfigureSchoolPageProps {
    tenantId: string;
    schoolCode: string;

    apiService: ApiService;
    history: H.History;
}

interface ConfigureSchoolPageState {
    school?: School;
    
    configOnServer: string;
    configLocally: string;
}

class ConfigureSchoolPage extends Component<ConfigureSchoolPageProps & DispatchProps ,ConfigureSchoolPageState> {
    static displayName = ConfigureSchoolPage.name;

    constructor(props: ConfigureSchoolPageProps & DispatchProps) {
        super(props);

        this.state = {
            school: undefined,
            configOnServer: "",
            configLocally: "",
        }

    }

    async componentDidMount() {
        if(this.props.tenantId && this.props.schoolCode)
        {
            const school = await this.props.apiService.getSchoolAdmin(this.props.tenantId,this.props.schoolCode)
            this.setState({
                school: school
            });
        }
    }

    async componentDidUpdate(prevProps: Readonly<ConfigureSchoolPageProps & DispatchProps>, prevState: ConfigureSchoolPageState): Promise<void> {

        if (this.props.tenantId !== prevProps.tenantId || this.props.schoolCode !== prevProps.schoolCode) {
            const school = await this.props.apiService.getSchoolAdmin(this.props.tenantId,this.props.schoolCode)
            this.setState({
                school: school
            });
        }

        if (this.state.school !== prevState.school) {
            await this.fetchConfigOnServer();
            this.resetLocalToServer();
        }
    }
    
    private async fetchConfigOnServer() {
        if (!this.state.school) {
            return;
        }

        const configOnServer = await this.props.apiService.getSchoolConfigXml(this.state.school);

        this.setState({
            configOnServer: configOnServer,
        });
    }
    
    private resetLocalToServer() {
        
        this.setState({
            configLocally: this.state.configOnServer
        })
    }
    
    private onChange = (values: string[]) => {

        this.setState({
            configOnServer: this.state.configOnServer,
            configLocally: values[1],
        });
    };
    
    private saveConfig = async (): Promise<void> => {

        if (!this.state.school) {
            return;
        }
        
        if(this.state.configLocally.length === 0)
        {
            return;
        }
        
        try
        {
            await this.props.apiService.putSchoolConfigXml(this.state.school,this.state.configLocally);
            await this.props.dispatch(Actions.showMessageBar("Config saved",MessageBarType.success));
            
        }
        catch(e)
        {
            await this.props.dispatch(Actions.showMessageBar(e.message,MessageBarType.error));
        }
        
    };

    render() {
        return (
            <Fragment>
                <SchoolPageTitle tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} title="Advanced" />
                <AdminSchoolMenu tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} />
                <div className="card card flex-item--flex-1">

                    <div className="card__header">
                        <span className={"card__title"}>Configure {this.state.school?.schoolName}</span>

                        <CommandBarButton
                            iconProps={{iconName: "Refresh"}}
                            text="Reset editor"
                            onClick={async () => {
                                await this.fetchConfigOnServer();
                                this.resetLocalToServer();
                            }}
                        />

                        <CommandBarButton
                            iconProps={{iconName: "Save"}}
                            text="Save"
                            onClick={async () => {
                                await this.saveConfig();
                                await this.fetchConfigOnServer();
                            }}
                        />
                    </div>

                    <div className="cdb-table__row cdb-table__row--header">
                        <div className="cdb-table__cell flex-item--flex-1">Config in cloud (read only)</div>
                        <div className="cdb-table__cell flex-item--flex-1">Your Config</div>
                    </div>

                    <DiffEditor
                        mode="xml"
                        onChange={this.onChange}
                        value={[this.state.configOnServer,this.state.configLocally]}
                        name="configEditor"
                        width="98%"
                        height="100%"
                    />

                </div>

                <div className="flex-row" style={{height: "20rem"}}>
                <div className="card flex-item--flex-1 flex--justify-content-center" style={{width: "50%", display: "flex"}}>

                    <div className="flex-row card__header">
                        <div className="flex-item--flex-1 flex--justify-content-center card__title" style={{display: 'flex'}}>Sample Config</div>
                    </div>

                    <div className="flex-row flex-item--flex-1 flex--justify-content-center">
                        <AceEditor
                            mode="xml"
                            value={SampleConfig.Xml}
                            height="100%"
                            width="100%"
                            wrapEnabled={true}
                            readOnly={true}
                            name="sampleConfigXml"
                        />
                    </div>
                        
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState,ownProps: any): ConfigureSchoolPageProps => {

        const tenantId = ownProps.match.params.tenantId;
        const schoolCode = ownProps.match.params.schoolCode;
        
        return {
            tenantId,
            schoolCode,
            apiService: state.auth.apiService,
            history: ownProps.history,
        };
    }
)(ConfigureSchoolPage)